<template>
  <ViewWrapper class="about-ocean" :scrollable="true" @close="$router.replace({ name: 'summary' })">
    <div class="about-ocean__inner">
      <h2 class="about-ocean__headline">{{ $t('view.aboutOcean.headline') }}</h2>
      <p>{{ $t('view.aboutOcean.copy') }}</p>

      <h3>{{ $t('view.aboutOcean.subhead') }}</h3>
      <ButtonPill
        class="about-ocean__button"
        :href="$t('view.aboutOcean.buttonUrl')"
        target="_blank"
        :download="isIOS ? undefined : ''"
      >
        {{ $t('ui.moreInformation') }}
      </ButtonPill>
    </div>
  </ViewWrapper>
</template>

<script>
import ButtonPill from '../components/ButtonPill';
import ViewWrapper from '../components/ViewWrapper';
import { isIOS } from '../utils/helpers';

export default {
  name: 'AboutOcean',

  components: {
    ButtonPill,
    ViewWrapper,
  },

  computed: {
    isIOS,
  },
};
</script>

<style lang="scss" scoped>
.about-ocean {
  background-color: rgba($color-black, $view-overlay-alpha-dark);
  @include helper__box-shadow_overlap($color-black);
}

.about-ocean__inner {
  max-width: 320px;
  margin-top: 80px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 20px;
  padding-right: 20px;

  p {
    line-height: 26px;
    margin-bottom: 40px;
  }

  h3 {
    font-size: 15px;
    margin-top: 20px;
    margin-bottom: 20px;
  }
}

.about-ocean__headline {
  font-size: 35px;
  text-align: left;
  margin-bottom: 20px;
  font-weight: bold;
}

.about-ocean__button {
  max-width: 200px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 40px;
  margin-bottom: 40px;
}
</style>
